var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"color":"yellow","cursor":"pointer"},on:{"click":_vm.OpenChat}},[_vm._v("Need Help?")])}
var staticRenderFns = []

export { render, staticRenderFns }